import { UseFormValues } from "@formiz/core/dist/types/form.types";
import { NotificationType, useSuggestion } from "@next-platform/client-common-core";
import { useState } from "react";

import { FormTypes } from "@/types";

import useToast from "./useToast";

interface UseFieldsSuggestionProps {
  form?: UseFormValues;
  formType?: FormTypes;
  onFieldValueChange?: (value: string) => void;
}

export const useFieldsSuggestion = ({ form, formType, onFieldValueChange }: UseFieldsSuggestionProps) => {
  const [activeGeneratingField, setActiveGeneratingField] = useState<string | null>(null);
  const { onUserSuggestField } = useSuggestion();
  const { displayToast } = useToast();

  const getAllSuggestFieldValues = (form: UseFormValues | undefined) => {
    if (formType === FormTypes.PERSONA) {
      return {
        name: form?.values?.name || "",
        highlights: form?.values?.highlights || "",
      };
    }

    return {
      name: form?.values?.name || "",
      title: form?.values?.title || "",
      persona: form?.values?.persona || "",
      greeting: form?.values?.greeting || "",
      scenario: form?.values?.scenario || "",
      dialogue: form?.values?.dialogue || "",
    };
  };

  const handleGenerateSuggestField = async (field: string) => {
    setActiveGeneratingField(field);
    const { data: response, error } = await onUserSuggestField({
      field,
      field_values: getAllSuggestFieldValues(form),
    });

    const value = response?.suggested_value ?? "";

    setActiveGeneratingField(null);

    let errorMessage = "";
    if (!value || typeof value !== "string" || value.trim() === "") {
      errorMessage = "Suggestion timed out. Please try again.";
    }
    if (error) {
      errorMessage = error;
    }
    if (errorMessage) {
      displayToast({ message: errorMessage, type: NotificationType.error });
      return;
    }

    form?.setFieldsValues({ [field]: value }, { keepPristine: false });

    if (field === "image" && onFieldValueChange) {
      onFieldValueChange(value);
    }
  };

  return {
    handleGenerateSuggestField,
    activeGeneratingField,
    getAllSuggestFieldValues,
  };
};
